// Core components
import { Component, SimpleChange } from "@angular/core";
import { MatDialog } from "@angular/material";

// Third party components
import { FieldArrayType } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject, Subscription } from "rxjs";
import { take } from "rxjs/operators";

// Custom components
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";

/**
 * Script start
 */
@Component({
  selector: "formly-repeat-structure-options-section",
  templateUrl: "./repeat-structure-options-type.component.html",
  styleUrls: ["./repeat-structure-options-type.component.scss"]
})
export class RepeatStructureoptionsTypeComponent extends FieldArrayType {
  private subscriptions: Subscription[] = [];
  onDestroy$ = new Subject<void>();
  private availableOptions: any[] | Observable<any[]> = [];
  private delBntenable= true;

  constructor(
    private translateService: TranslateService,
    private dialog: MatDialog
  ) {
    super();
  }
  
  /**
   * Init component
   *
   * @since 1.0.0
   */
   ngOnInit(): void {
    this.to.add = this.add.bind(this);
    this.to.remove = this.remove.bind(this);
  }

  /**
   * Listen on input values changes
   *
   * @since 1.0.0
   */
  ngOnChanges(changes: SimpleChange): void {

  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handle click on "Remove section" button and trigger a confirmation dialog to ask user if
   * he confirm to remove row. If yes, than remove row.
   *
   * @since 1.0.0
   */
  onRemove(indexToRemove: number): void {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.translateService.instant("dialogs.confirm.title"),
        message: this.translateService.instant("dialogs.confirm.removeMessage"),
        btnOkText: this.translateService.instant("common.cta.confirm"),
        btnCancelText: this.translateService.instant("common.cta.close")
      },
      width: "500px",
      disableClose: true
    });
    // Subscribe to dialog result (only for 1 emit thanks to "take()")
    this.subscriptions.push(
      dialogRef
        .beforeClosed()
        .pipe(take(1))
        .subscribe(res2 => {
          if (res2) {
            // Actually delete field
            this.remove(indexToRemove);
          }
        })
    );
  }

  
}
